import { MarkerActivityModel, MarkerCompetencyModel, MarkerContentModel,
    MarkerContextModel, MarkerLearnerModel, MarkerResultModel } from '@/models/marker/marker';
import moment from 'moment';
import momentTime from 'moment-timezone';

export default class ShowcaseForm {

    public result: MarkerResultModel = {
        reaction: 0,
        timeSpent: 0,
        maxScore: 100,
        score: 0,
    };

    public learner: MarkerLearnerModel  = {
        learnerId: '',
        dok: 'Level 1: Recall',
        resourcePref: {},
        struggles: [],
        confidence: 0.6,
    };

    public activity: MarkerActivityModel = {
        type: 'assessment.complete',
        activityTime: 0,
        timezone: momentTime.tz.guess(),
        dateInTimezone: moment().format('YYYY-MM-DD'),
    };

    public content: MarkerContentModel = {
        contentId: '',
        contentType: '',
        attempt: 1,
        attemptId: '',
        questionCount: 0,
    };

    public competency: MarkerCompetencyModel = {
        dependency: {},
    } as MarkerCompetencyModel;

    public context: MarkerContextModel = {
        minMasteryScore: 80,
        ecpaRules: [],
    } as MarkerContextModel;

    constructor(private userId: string) {
        this.learner.learnerId = userId;
    }

}
